export default {
  // Used icon in rms
  rms_edit: 'mdi-pencil',
  rms_delete: 'mdi-delete',
  rms_agreement: 'mdi-file-document-box-outline',
  rms_upload: 'mdi-upload',
  rms_emoticon_sad: 'mdi-emoticon-sad',
  rms_circle_outline: 'mdi-circle-outline',
  rms_check_filled: 'mdi-check-circle',
  rms_dot: 'more_vert',
  rms_company: 'mdi-office',
  rms_company_switch: 'mdi-account-switch',
  rms_invite_peoples: 'mdi-message-text',
  rms_settings: 'mdi-settings',
  rms_filter: 'mdi-filter',
  rms_favorite_outline: ' mdi-heart-outline',
  rms_favorite_filled: 'mdi-heart',
  rms_tag: 'mdi-tag',
  rms_movie: 'mdi-movie',
  rms_file: 'mdi-file',
  rms_map: ' mdi-map-marker-multiple',
  rms_desktop: 'mdi-desktop-mac',
  rms_film: 'mdi-film',
  rms_share: 'mdi-share-variant',
  rms_disabled: 'mdi-close-circle-outline',
  rms_active: 'mdi-checkbox-marked-circle-outline',
  rms_user: 'mdi-account',
  rms_calander: 'mdi-calendar',
  rms_movie_availibility_icon: 'mdi-checkbox-blank-circle',
  rms_vedio_file: 'mdi-file-video',
  rms_go_forward: 'mdi-arrow-right',
  rms_go_backward: 'mdi-arrow-left',
  rms_image_not_found: 'mdi-image-area',
  rms_down_arrow: 'mdi-chevron-double-down',
  rms_reset: 'mdi-sync',
  rms_not_found: 'mdi-emoticon-sad',
  rms_view: ' mdi-eye',
  rms_user_circle: 'mdi-account-circle',
  rms_filter_line: 'mdi-filter-outline',
  rms_company_select_icon: 'mdi-login-variant',

  // All icons

  rms_bell: 'mdi-bell',
  rms_firefox: 'mdi-firefox',
  rms_chrome: 'mdi-google-chrome',
  rms_safari: 'mdi-apple-safari',
  rms_android_browser: 'mdi-android',

  rms_session_device_desktop: 'mdi-laptop',
  rms_session_device_mobile: 'mdi-cellphone-android',
  rms_session_device_tablet: 'mdi-tablet',

  rms_session_list: 'mdi-view-list',
  rms_refresh: 'mdi-refresh',
  rms_receive_money: 'mdi-arrow-bottom-left',
  rms_login: 'mdi-login',
  rms_register: 'mdi-account-plus',
  rms_network_level1: 'mdi-numeric-1-box-outline',
  rms_network_level2: 'mdi-numeric-2-box-outline',
  rms_network_commission: 'mdi-cash',
  rms_network_count: 'mdi-account-network',
  rms_copy: 'mdi-file-multiple',
  rms_cash_balance: 'mdi-cash',
  rms_bank: 'mdi-bank',
  rms_txn_status_approved: 'mdi-checkbox-marked-circle',
  rms_txn_status_freezed: 'mdi-lock',
  rms_txn_status_prepare: 'mdi-pencil-box-outline',
  rms_txn_status_cancel: 'mdi-cancel',
  rms_video: 'mdi-video',

  rms_user_recharge: 'mdi-cash-multiple',
  rms_mobile: 'mdi-cellphone',
  rms_email: 'mdi-email',

  rms_contact_support: 'mdi-help-box',
  rms_idproof_add: 'mdi-account-badge',
  rms_idproof_business: 'mdi-account-badge',

  rms_id_proof_default: 'mdi-image-plus',
  /**not found in mdi */
  rms_locale: 'language',
  rms_logout: 'mdi-exit-to-app',

  rms_sad: 'mdi-alert',

  rms_close: 'mdi-close',
  rms_date: 'mdi-calendar',
  rms_add: 'mdi-plus-box',

  rms_go_back: 'mdi-chevron-left',
  rms_clear: 'mdi-close-circle-outline',

  rms_credit_tree: 'mdi-chevron-up',
  rms_debit_tree: 'mdi-chevron-down',

  rms_send_money: 'mdi-arrow-top-right',
  rms_send_money_to_registered: 'mdi-wallet',
  rms_send_money_to_unregistered: 'mdi-account-question',
  rms_send_money_in_bank: 'mdi-bank-transfer-in',

  rms_recharge_wallet: 'mdi-plus-box',

  rms_get_money: 'mdi-arrow-bottom-left',
  rms_get_money_request_money: 'mdi-arrow-bottom-left',
  rms_recharge_wallet_topup: 'mdi-wallet-outline',
  rms_get_money_cash_pickup: 'mdi-cash',

  rms_partner: 'mdi-account-star-outline',
  rms_partner_deposit: 'mdi-cash-register',
  rms_partner_withdraw: 'mdi-cash-multiple',
  rms_user_rewards: 'mdi-gift',
  rms_partner_commission: 'mdi-gift',

  rms_wallet: 'mdi-wallet',
  rms_wallet_balance: 'mdi-wallet',
  rms_wallet_list_item: 'mdi-wallet-outline',
  rms_wallet_add: 'mdi-plus-box',
  rms_wallet_status: 'mdi-lock',
  rms_wallet_currency: 'mdi-coin',
  rms_wallet_profile: 'mdi-account-box',
  rms_wallet_idproofs: 'mdi-file-account',
  rms_wallet_bank_account: 'mdi-bank',
  rms_wallet_child: 'mdi-account-child',
  rms_wallet_switcher: 'mdi-wallet',
  rms_icon_missing: 'mdi-image-broken',

  rms_send_moeny_qr_scan: 'mdi-qrcode',

  rms_account: 'mdi-account-box',
  rms_dashboard: 'mdi-home',
  rms_consumer_dashboard: 'mdi-view-dashboard',
  rms_transactions: 'mdi-format-list-checkbox',
  rms_scan: 'mdi-qrcode-scan',
  rms_locked: 'mdi-lock',
  rms_network: 'mdi-trending-up',
  rms_countdown: 'mdi-timer',
  rms_goback: 'mdi-chevron-left',
  rms_setpin: 'mdi-shield-lock',
  rms_next: 'mdi-chevron-right',
  rms_tnc: 'mdi-file-check',
  rms_user_profile: 'mdi-account-details',
  rms_onboarding_welcome: 'mdi-emoticon-excited-outline',

  rms_wallet_approved: 'mdi-check-decagram',
  rms_wallet_awaited: 'mdi-timer-sand',
  rms_wallet_freeze: 'mdi-book-lock',
  rms_wallet_block: 'mdi-block-helper',
  rms_wallet_closed: 'mdi-close-box',

  rms_rule_is_enabled: 'mdi-checkbox-marked-circle',

  rms_rule_reset_filters: 'mdi-refresh',
  rms_rule_arrow_upward: 'mdi-arrow_upward',

  rms_message_list: 'mdi-bell',
  rms_rules: 'mdi-format-list-checkbox',
  rms_country_combinations: 'mdi-format-list-checkbox',
  rms_maintenance: 'mdi-cloud-off-outline',

  rms_visibility: 'mdi-eye',
  rms_visibility_off: 'mdi-eye-off',

  mobile: 'mdi-cellphone',
  city: 'mdi-city',
  user: ' mdi-account',
  rms_check: 'mdi-check-circle',
  streaming_on: 'mdi-video',
  streaming_off: 'mdi-video-off',
  country_flag: 'mdi-flag-variant',
  screener_btn_play: 'mdi-play-circle-outline',
  screener_error: 'mdi-close-circle',
  screener_calendar: 'mdi-calendar-today',
  message: 'mdi-message',
  send: 'mdi-send',
  rms_save: 'mdi-content-save',
  rms_navigation: 'mdi-near-me',
  rms_print: "mdi-printer",
  rms_download: "mdi-download",
  rms_check_without_circle: 'mdi-check',
  rms_download: "mdi-download",
  rms_sync: 'mdi-sync',
  rms_clock: 'mdi-clock'
};
